import { useTranslation } from "@redotech/redo-i18n";
import { InteractiveMapLocation } from "@redotech/redo-model/draft-return/draft-return";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { LocationsMapModalBody } from "@redotech/redo-web/arbiter-components/interactive-map/interactive-map";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { useQuery } from "@tanstack/react-query";
import { memo, useState } from "react";

export interface ReturnBearLocationsSearchParams {
  draftReturnId?: string;
  returnId?: string;
}

export const ReturnBearLocationsButton = memo(
  function ReturnBearLocationsButton({
    draftReturnId,
    returnId,
    autoOpen = false,
    searchReturnBearLocations,
  }: {
    draftReturnId?: string;
    returnId?: string;
    autoOpen?: boolean;
    searchReturnBearLocations: (
      params: ReturnBearLocationsSearchParams,
    ) => Promise<InteractiveMapLocation[]>;
  }) {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(autoOpen);
    const query = useQuery({
      queryKey: ["returnBearLocations", draftReturnId, returnId],
      queryFn: () => searchReturnBearLocations({ draftReturnId, returnId }),
      enabled: isOpen,
      staleTime: Infinity,
    });

    return (
      <Flex>
        <RedoButton
          hierarchy="secondary"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(true);
          }}
          text={t("See available locations")}
        />
        <RedoModal
          isOpen={isOpen}
          onModalCloseRequested={() => setIsOpen(false)}
          title={t("Find Return Bear drop-off locations")}
        >
          <LocationsMapModalBody
            error={!!query.error}
            errorText={t("Error loading Return Bear locations")}
            locations={query.data ?? null}
            pending={query.isPending && query.fetchStatus !== "idle"}
          />
        </RedoModal>
      </Flex>
    );
  },
);
